import React from "react";
import {AttendanceStatus, Contact} from "../../schema";
import {useHistory} from "react-router";
import {reverse} from "../../urls";
import DateTimeFormatter from "../../models/formatter/DateTimeFormatter";
import {DateTime} from "luxon";
import PriceFormatter from "../../models/formatter/PriceFormatter";
import Table, {TableFilter} from "../../ui/table/Table";
import IconPaid from "../icon/IconPaid";

type TableData = {
  startDate: string;
  eventTitle: string;
  payment: React.ReactNode;
  attendeeId: string;
  status: React.ReactNode;
}

type Props = {
  contact: Contact
}

export default function ParticipationHistoryTab({contact}: Props) {
  const history = useHistory();

  const tableData: TableData[] = React.useMemo(() => {
      return contact.attendance.map((attendance) => {
        const price = PriceFormatter.format({
          amount: attendance.paidAmount,
          currency: attendance.paidCurrency
        });
        let status: React.ReactNode = '';
        switch (attendance.status) {
          case AttendanceStatus.CANCELLED:
            status = <span className="text-red">Cancelled</span>;
            break;
          case AttendanceStatus.PARTICIPATED:
            status = <span className="text-green">Participated</span>;
            break;
          case AttendanceStatus.TRANSFERRED:
            status = <span>Transferred</span>;
            break;
          default:
            status = <span>Registered</span>;
        }
        const priceLine = attendance.paid ? <span>{price} <IconPaid className="text-green"/></span> : price;
        return ({
          startDate: DateTimeFormatter.format('en-GB', DateTime.fromISO(attendance.startDate)),
          eventTitle: attendance.eventTitle,
          attendeeId: attendance.attendeeId,
          status: status,
          payment: attendance.eventFree ? <span className="text-green">Free</span> : priceLine
        });
      })
    }, [contact]
  );

  const onClick = (attendance: TableData) => {
    history.push(reverse('attendees_detail', {id: attendance.attendeeId}));
  }

  const columns = React.useMemo(() => [
    {
      Header: 'Participation History',
      columns: [
        {
          Header: 'Start date',
          accessor: 'startDate',
          filter: 'fuzzyText',
          defaultSort: 'desc',
          sortType: 'basic',
        },
        {
          Header: 'Title',
          accessor: 'eventTitle',
          filter: 'fuzzyText',
        },
        {
          Header: 'Payment',
          accessor: 'payment',
          filter: 'fuzzyText',
        },
        {
          Header: 'Status',
          accessor: 'status',
          filter: 'fuzzyText',
        }]
    }
  ].flatMap((c: any) => c.columns), []);

  return (
    <>
      <div className="bg-white overflow-hidden py-5 pt-3">
        <div className="mt-8">
          <Table<TableData, TableFilter> name="participation_history:v2" reset={false} total={tableData.length}
                                         loading={false} filters={[]} columns={columns}
                                         data={tableData} noPagination={true} noSearch={true}
                                         onClick={onClick}/>
        </div>
      </div>
    </>
  );
}
